import * as api from '../api'
import { STORE_CONTENT, STORE_COURSE_STRUCTURE, LOADING_START, LOADING_END, STORE_PROGRESS, STORE_AND_PROCESS_SUPPORT, CLEAR_ALL_PROGRESS, STORE_COMMENT, STORE_COURSE_TITLE} from '../constants/actionConstants';
import { update_tags_all } from '../components/Global/utils';
import { link_support_references } from '../components/Global/SupportUtils';

// Fetch the content that we are currently working through.
export const fetchCurrentContent= (courseID, navigate) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        dispatch({type: CLEAR_ALL_PROGRESS})

        var {data} = await api.fetchCurrentContent(courseID) ; 
        // Add every equation and figure to support and add links to text
        data = link_support_references(data) ; 

        // Store the content and the overall course structure
        dispatch({type: STORE_PROGRESS, payload: data.progress})
        dispatch({type: STORE_CONTENT, payload: data.content});
        dispatch({type: STORE_COMMENT, payload: data.comments})
        dispatch({type: STORE_COURSE_STRUCTURE, payload: data.course_structure});
        dispatch({type: STORE_COURSE_TITLE, payload:data.course_title})
        dispatch({type: STORE_AND_PROCESS_SUPPORT, payload: {support: data.support, references:data.references}})
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        // If an error, then failed to login;  navigate back to the home page
        navigate('/')
        console.log(error.message) ; 
    }
}

// Update the tags in the content as a whole
export const updateContentTags= (courseID, navigate) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        const {data} = await api.fetchCurrentContent(courseID) ; 
        // Store the content and the overall course structure
        const updated_content = update_tags_all(data.content) ; 
        for (let c_content = 0 ; c_content < updated_content.length; c_content++)
        {
            dispatch(updateContent(updated_content[c_content]._id, updated_content[c_content]))
        }
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        // If an error, then failed to login;  navigate back to the home page
        navigate('/')
        console.log(error.message) ; 
    }
}


// Fetch the content specified by ID (for editing)
export const fetchContent= (contentID, navigate) => async (dispatch) => {
    try {
        console.log("Fetching content")
        dispatch({ type: LOADING_START }) ; 
        const {data} = await api.fetchContent(contentID) ;
        // Store the content and the overall course structure, and the progress so far
        dispatch({ type: STORE_CONTENT, payload: [data]});
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        // If an error, then failed to login;  navigate back to the home page
        navigate('/')
        console.log(error.message) ; 
    }
}



// Updates a content item
export const updateContent = (id, content) => async (dispatch) => {
    try{
        await api.updateContent(id, content) ;
    } catch(error) {
        console.log(error)
    }
}

